import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from 'react-redux';
import { Link, useNavigate,useLocation  } from 'react-router-dom'
import axios from 'axios';
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

export default function PaymentSuccess() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
  
    const paymentIntent = queryParams.get("payment_intent");

    var addPayment = localStorage.getItem('add_payment');
    var orderId = localStorage.getItem('orderId');
    var addPaymentObject = JSON.parse(addPayment);
    var orderIdObject = JSON.parse(orderId);
    const [response, setResponse] = useState({})
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        console.log('addPaymentObject', orderIdObject)
        axios.post(`${process.env.REACT_APP_API_URL}stripe.php`, {
            action: "CheckPaymentAdvertisement",
            order_id: orderIdObject,
            datebaseid: addPaymentObject,
            paymentIntent:paymentIntent
        })
            .then((response) => {
                setResponse(response.data)
                console.log('response', response.data);
            })
            .catch((error) => {
                console.error('Error updating payment status:', error);
            })
            .finally(() => setLoading(false)); 
    }, [orderIdObject]);

    return (
        <section className="sale-items-sec sec-padding">
            <div className="container-fluid">
            {loading ? (
                <div className="sec-title text-center">
                    <h3>Checking Payment Status...</h3>
                </div>
            ) : response?.status === true ? (
                <div className="sec-title text-center">
                    <div className="cicle p-2 mb-4">
                        <i className="fa fa-check text-primary" style={{ fontSize: '50px' }}></i>
                    </div>
                    <h3>Payment Success</h3>
                    <p className="text-center pt-3">Congratulations! Your payment has been successfully processed.</p>
                </div>
            ) : (
                <div className="sec-title text-center">
                    <div className="p-2 mb-4">
                        <i className="fa fa-times-circle-o text-danger" style={{ fontSize: '50px' }}></i>
                    </div>
                    <h2 className="text-danger">{response?.payment_status || 'Payment Failed'}</h2>
                    <p className="text-center pt-3">{response?.message || "Something went wrong."}</p>
                </div>
            )}

                        <div className="sales-items"><div>
                            <div className="text-center m-2">
                                <a href="/advertisement" className="btn btn-outline-primary">View All Advertisement</a>
                            </div>
                        </div>
                        </div>
                    </div>
        </section>
    )
}
